import { Injectable } from '@angular/core';

import { DataReactionAction, DataReactionSpaceScope } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import {
  DataEntityActionPresenterModel,
  TriggerSpaceScopeEnum,
} from '@osos/shared/types';
import { DataEntityActionParserV1Service } from '../../parsers/data-entity-action-parser/data-entity-action-parser-v1.service';

@Injectable()
export class DataEntityActionFactoryService extends FactoryBase<
  DataReactionAction,
  DataEntityActionPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataEntityActionParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  parseTriggerSpaceScopeEnum(
    model: DataReactionSpaceScope,
  ): TriggerSpaceScopeEnum {
    if (!model) {
      return TriggerSpaceScopeEnum.TRIGGERING_SPACE;
    }
    const { currentSpace, otherSpaces, rootSpace } = model;

    if (currentSpace && !otherSpaces && !rootSpace) {
      return TriggerSpaceScopeEnum.TRIGGERING_SPACE;
    } else if (rootSpace && !currentSpace && !otherSpaces) {
      return TriggerSpaceScopeEnum.ROOT_SPACE;
    } else if (rootSpace && currentSpace && !otherSpaces) {
      return TriggerSpaceScopeEnum.ROOT_SPACE_AND_TRIGGERING_SPACE;
    } else if (otherSpaces && !rootSpace) {
      return TriggerSpaceScopeEnum.ALL_SPACES_EXCEPT_ROOT;
    } else if (currentSpace && otherSpaces && rootSpace) {
      return TriggerSpaceScopeEnum.ALL_SPACES;
    }

    throw new Error('Invalid DataReactionSpaceScope model');
  }

  parseTriggerScopeEnumToModel(
    enumValue: TriggerSpaceScopeEnum,
  ): DataReactionSpaceScope {
    const flags = {
      rootSpace: false,
      currentSpace: false,
      otherSpaces: false,
    };
    switch (enumValue) {
      case TriggerSpaceScopeEnum.TRIGGERING_SPACE:
        return {
          ...flags,
          currentSpace: true,
        };
      case TriggerSpaceScopeEnum.ROOT_SPACE:
        return {
          ...flags,
          rootSpace: true,
        };
      case TriggerSpaceScopeEnum.ROOT_SPACE_AND_TRIGGERING_SPACE:
        return {
          ...flags,
          rootSpace: true,
          currentSpace: true,
        };
      case TriggerSpaceScopeEnum.ALL_SPACES_EXCEPT_ROOT:
        return {
          ...flags,
          otherSpaces: true,
        };
      case TriggerSpaceScopeEnum.ALL_SPACES:
        return {
          ...flags,
          rootSpace: true,
          currentSpace: true,
          otherSpaces: true,
        };
    }
  }

  createDataModel(
    presenter: DataEntityActionPresenterModel,
  ): DataReactionAction {
    //@TODO use presenter.specificationVersion
    const parser = this.getParser(
      DataReactionAction,
      DataEntityActionPresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: DataReactionAction,
  ): DataEntityActionPresenterModel {
    //@TODO use model.specificationVersion
    const parser = this.getParser(
      DataReactionAction,
      DataEntityActionPresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
